/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkshopAttendanceRead } from './WorkshopAttendanceRead';
import {
    WorkshopAttendanceReadFromJSON,
    WorkshopAttendanceReadFromJSONTyped,
    WorkshopAttendanceReadToJSON,
    WorkshopAttendanceReadToJSONTyped,
} from './WorkshopAttendanceRead';

/**
 * Result of adding several participants at once.
 * @export
 * @interface WorkshopAttendanceBulkResult
 */
export interface WorkshopAttendanceBulkResult {
    /**
     * 
     * @type {Array<WorkshopAttendanceRead>}
     * @memberof WorkshopAttendanceBulkResult
     */
    added: Array<WorkshopAttendanceRead>;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceBulkResult
     */
    skipped: number;
}

/**
 * Check if a given object implements the WorkshopAttendanceBulkResult interface.
 */
export function instanceOfWorkshopAttendanceBulkResult(value: object): value is WorkshopAttendanceBulkResult {
    if (!('added' in value) || value['added'] === undefined) return false;
    if (!('skipped' in value) || value['skipped'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceBulkResultFromJSON(json: any): WorkshopAttendanceBulkResult {
    return WorkshopAttendanceBulkResultFromJSONTyped(json, false);
}

export function WorkshopAttendanceBulkResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceBulkResult {
    if (json == null) {
        return json;
    }
    return {
        
        'added': ((json['added'] as Array<any>).map(WorkshopAttendanceReadFromJSON)),
        'skipped': json['skipped'],
    };
}

export function WorkshopAttendanceBulkResultToJSON(json: any): WorkshopAttendanceBulkResult {
    return WorkshopAttendanceBulkResultToJSONTyped(json, false);
}

export function WorkshopAttendanceBulkResultToJSONTyped(value?: WorkshopAttendanceBulkResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'added': ((value['added'] as Array<any>).map(WorkshopAttendanceReadToJSON)),
        'skipped': value['skipped'],
    };
}

